// INFODATA server
export const API_URL = 'https://apiponude.infodata.hr/api';

// // INFOBIT server novi
// export const API_URL = 'http://apiponude.infobit.info/api';

// INFOBIT server stari
// export const API_URL =
//     'http://services.infobit.info/Infodata/Servis.Prijava.Api/api';
